import React, { Component } from "react";
import axios from "axios";
import { connect } from "react-redux";
import { selectItems } from "../../components/actions/authAction";
import PageTitle from "../../components/common/PageTitle";
import {
  Container,
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  Button,
} from "shards-react";

class LearningResourceClassList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      classes: [],
    };
  }

  selectItems = (id) => {
    const items = {
      id: id,
    };
    localStorage.setItem("id", id);
    this.props.selectItems(items);
    this.props.history.push("/learning-resources-class/edit");
  };

  deleteClass = (id) => {
    if (!window.confirm("Are you sure?")) {
      return false;
    }

    axios
      .delete(
        `${process.env.REACT_APP_API_URL}/learning-resource-class/${id}`,
        {
          headers: { "x-access-token": localStorage.getItem("jwtToken") },
        }
      )
      .then((res) => {
        if (res.status === 200) {
          window.location.href = "/learning-resources-class";
        }
      });
  };
  getClasses = () => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/learning-resources-classes`)
      .then((res) => {
        this.setState({
          classes: res.data.resources,
        });
      });
  };

  componentDidMount() {
    this.getClasses();
  }

  render() {
    return (
      <React.Fragment>
        <Container fluid className="main-content-container px-4">
          <Row noGutters className="page-header py-4">
            <PageTitle
              sm="4"
              title="Learning Resources"
              subtitle="Add new Classes"
              className="text-sm-left"
            />
            <div className="add-new">
              <Button
                className="add-new-btn"
                onClick={() =>
                  this.props.history.push("/learning-resources-class/add")
                }
              >
                Add New Class
              </Button>
            </div>
          </Row>
          <Row>
            <Col>
              <Card small className="mb-4">
                <CardHeader className="border-bottom">
                  <div className="lead font-weight-bold">Class</div>
                </CardHeader>
                <CardBody className="p-0 pb-3">
                  <table className="table mb-0 " id="my-table">
                    <thead className="bg-light">
                      <tr>
                        <th scope="col" className="border-0">
                          Class
                        </th>
                        <th scope="col" className="border-0 exclude-pdf">
                          Action
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.classes.map((item, index) => (
                        <tr key={index}>
                          <td> {item.title}</td>
                          <td>
                            <Button onClick={() => this.selectItems(item._id)}>
                              Edit Class
                            </Button>
                            <br />

                            <br />
                            <Button
                              theme="danger"
                              onClick={() => this.deleteClass(item._id)}
                            >
                              Delete Class
                            </Button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </React.Fragment>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    items: state.itemReducer,
  };
};

export default connect(mapStateToProps, {
  selectItems,
})(LearningResourceClassList);
